module.exports = __webpack_public_path__ + "img/intro01.93a4615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intro/intro01.png
// module id = 941
// module chunks = 1